/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';

const initialState = {
  planType: [],
  rebateProgramList: [],
  rebateProgramNameValue: '',
  selectedPlanType: '',
  rebateProgramValue: '',
  errors: [],
  searchScreen: {
    isAllManufacturersSelected: true,
  },
  rebateProgramName: '',
  manufacturerList: [],
  dramsQtr: '',
  searchResult: [],
  fromQuarter: '',
  toQuarter: '',
  rangeType: 'drams',
  manufacturerSelected: [],
  manufacturerSelectedName: [],
  isAllManufacturersSelected: true,
  scrollDownManufacturers: true,
  selectedRowIndexValue: [],
  exportAllData: {},
  exportAllData: {},
  displayObj: {
    rebateProgramList: [],
    rebateProgramValue: '',
    rebateProgrameName: '',
    searchResult: [],
    rangeType: 'drams',
    fromQuarter: '',
    toQuarter: '',
    isAllManufacturersSelected: true,
    manufacturerList: [],
    isManufacturerListFetched: false,
  },
};
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    // case ActionTypes.GET_REBATE_PROGRAM_REBATE_PERCENT:
    //   return { ...state, rebateProgramList: action.payload };
    case ActionTypes.SET_SELECTED_REBATE_PERCENT:
      return { ...state, ...action.payload };
    case ActionTypes.IS_LOADING_ADJUSTMENT_REBATE_PERCENT:
      return { ...state, isLoading: action.isLoading };
    // Manufacturer Grid
    case ActionTypes.GET_MANUFACTURER_LIST_REBATE_PERCENT:
      return {
        ...state,
        manufacturerList: action.manufacturerList,
        isManufacturerListFetched: true,
      };
    case ActionTypes.FIRST_SUMMARY_VALUE:
      return { ...state, firstSumQtr: action.payload };
    case ActionTypes.GET_DRAMS_QUARTER:
      return { ...state, dramsQtr: action.dramsQtr };
    // For Search Screen result API
    case ActionTypes.GET_SEARCH_RESULT_REBATE_PERCENT:
      const displayObj = {
        ...state.displayObj,
        searchResult: action.searchResult,
      };
      return { ...state, searchResult: action.searchResult, displayObj };
    case ActionTypes.REFRESH_REBATE_PERCENT:
      return { ...initialState, displayObj: state.displayObj };
    case ActionTypes.SET_EXPORT_ALL_REBATE_PERCENT:
      const { data, mfgIds } = action.payload;
      const exportAllData =
        mfgIds === 'noData' ? {} : { ...state.exportAllData, [mfgIds]: data };
      if (data?.length > 0) {
        return { ...state, exportAllData };
      }
      return {
        ...state,
      };
    case ActionTypes.SET_SELECT_ROWS:
      return {
        ...state,
        searchScreen: action.searchScreen,
      };
    case ActionTypes.SET_REFRESH_REBATE_PERCENT_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    default:
      return state;
  }
};

export default reducer;
